<template>
  <div class="fill-height">
    <app-nav :mini="mini" @navToggle="navToggle"></app-nav>
    <top-menu @navToggle="navToggle"></top-menu>

    <v-content>
      
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      
    </v-content>

    <app-footer></app-footer>
  </div>
</template>

<script>
  import { settings } from '~/config.js'

  export default {
    data: () => ({
      mini: false
    }),

    components: {
      'app-nav': require('./shared/AppNav').default,
      'top-menu': require('./shared/TopMenu').default,
      'app-footer': require('./shared/AppFooter').default
    },

    methods: {
      navToggle() {
        this.mini = !this.mini
      }
    }
  }
</script>
